export default {
    methods: {
        // 编辑页不需要，预览页才需要
        xijiaodaShowPSQ() {
            // let container = document.getElementById(`container_${this.myid.container_id}`)
            // let dialogDiv =  document.getElementById("psqDialog")
            // if(dialogDiv){
            //     container.removeChild(dialogDiv)
            // }
            // let dialog = document.createElement("div")
            // dialog.setAttribute('id','psqDialog')
            // dialog.setAttribute(
            //     "style",
            //     "position: fixed;left:0%;bottom:98px;width:260px;height:102px;background:red;z-index:99999"
            // )
            // dialog.innerHTML =`<div class="icon-portal-close-one1 close-psq" style="position: absolute;top:-5px;right: -12px;font-size: 24px;cursor: pointer; color:#fff;"></div><a href="http:www.baidu.com">点击填写问卷</a>`
            // container.appendChild(dialog)
            //
            //  dialogDiv = document.getElementById("psqDialog")
            // dialogDiv.getElementsByClassName("close-psq")[0].addEventListener("click",()=>{
            //     container.removeChild(dialogDiv)
            // })
        },
    }
}